//flickity gallery slider
//import 'flickity/css/flickity.css'

if ( $('.featuredGallery__slides').length ) {
  $('.featuredGallery__slides').imagesLoaded( function(){
    $('.featuredGallery__slides').flickity({
      //options
      wrapAround: false,
      pageDots: false,
      contain: true,
      draggable: false,
    });
  });
}



// WEBPACK FOOTER //
// ./wp-content/themes/figpress-child/src/js/modules/Slider.js